import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeAppleSignIn } from '../lib/firebase';
import { useAuth } from '../contexts/AuthContext';

/**
 * Handles the Apple Sign-In redirect callback.
 * The cloud API redirects here with id_token and state in the URL hash.
 * We decode the Apple token and sync directly with the cloud API
 * (bypassing Firebase auth which rejects the Services ID audience).
 */
export default function AppleCallbackPage() {
	const navigate = useNavigate();
	const { loginWithAppleToken } = useAuth();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const handleCallback = async () => {
			try {
				const hash = window.location.hash.substring(1);
				const params = new URLSearchParams(hash);
				const idToken = params.get('id_token');
				const state = params.get('state');

				if (!idToken || !state) {
					setError('Missing authentication data from Apple');
					return;
				}

				// Verify state and decode Apple token
				const appleUser = await completeAppleSignIn(idToken, state);

				// Sync directly with cloud API (no Firebase auth)
				await loginWithAppleToken(appleUser);

				navigate('/chat', { replace: true });
			} catch (err: any) {
				console.error('Apple callback error:', err);
				setError(err.message || 'Apple sign-in failed');
			}
		};

		handleCallback();
	}, [navigate, loginWithAppleToken]);

	if (error) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: '16px' }}>
				<p style={{ color: 'red' }}>{error}</p>
				<button onClick={() => navigate('/login', { replace: true })}>Back to Login</button>
			</div>
		);
	}

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
			<p>Completing sign-in...</p>
		</div>
	);
}
